// Utilitaire partagé : lance un pack multi-formats (job asynchrone) et attend la fin.
// runPosterPack -> renvoie le résultat (formats + zip_url) SANS télécharger (pour l'aperçu).
// downloadPosterPack -> ancien comportement (télécharge directement le ZIP).
export async function runPosterPack({ api, endpoint, body, maxPolls = 90 }) {
  const { data } = await api.post(endpoint, body || {});
  const jobId = data.job_id;
  if (!jobId) throw new Error("Pack non démarré");
  let result = null;
  for (let i = 0; i < maxPolls; i++) {
    // eslint-disable-next-line no-await-in-loop
    const { data: job } = await api.get(`/poster/job/${jobId}`);
    if (job.status === "done") { result = job.result; break; }
    if (job.status === "error") throw new Error(job.error || "Échec du pack");
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, 4000));
  }
  if (!result || !result.zip_url) throw new Error("Pack indisponible (délai dépassé)");
  return result;
}

// Télécharge un ZIP depuis une URL relative (préfixée par le backend).
export async function downloadZipFromUrl({ backendUrl, zipUrl, filename }) {
  const res = await fetch(`${(backendUrl || "").replace(/\/$/, "")}${zipUrl}`);
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename || "pack-affiches.zip";
  a.click();
  URL.revokeObjectURL(a.href);
}

export async function downloadPosterPack({ api, backendUrl, endpoint, body, filename, maxPolls = 90 }) {
  const result = await runPosterPack({ api, endpoint, body, maxPolls });
  await downloadZipFromUrl({ backendUrl, zipUrl: result.zip_url, filename });
  return result;
}
